import { apiClient } from '@/services/ApiClient'

export default {
  getMobileBanners() {
    return apiClient
      .get('mobile-banners')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobileBanner(id) {
    return apiClient
      .get('mobile-banners/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getAudiencesFromFirebaseRemoteConfig() {
    return apiClient
      .get('mobile-banners/get-audiences-from-firebase-remote-config')
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      })
  },
  deleteMobileBanner(id) {
    return apiClient
      .delete('mobile-banners/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createBanner(banner) {
    return apiClient
      .post('mobile-banners', banner)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateBanner(banner) {
    return apiClient
      .patch('mobile-banners/' + banner.id, banner)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
